import React from "react";
import Flagship from "../../core/flagship";
import RecentFavorites from "../dashboard/RecentFavorites";
import DecommissionedNotice from "../dashboard/DecommissionedNotice";
import { connect } from "react-redux";
import {
  Grid,
  Icon,
  Label,
  Header,
  Loader,
  Segment,
} from "semantic-ui-react";
import { Link } from "react-router";
import "../../styles/dashboard.scss";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
  }

  componentDidMount() {
    document.title = "Flagship / Dashboard";
  }

  render() {
    if (this.props.token !== null) {
      return (
        <div className="fade-in">
          <Grid className="dashboard-widget-container">
            <Grid.Row>
              <Grid.Column width={16}>
                <DecommissionedNotice />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column width={16} className="big-column">
                <Segment className="dashboard-favorites-widget">
                  <Header className="white-text">
                    My Favorites
                    <Link to="/user/favorites">
                      <Label size="small" className="view-all float-right">
                        <Icon name="caret right" />
                        View All
                      </Label>
                    </Link>
                  </Header>
                  <RecentFavorites
                    userId={this.props.userId}
                    instance={this.props.instance}
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      );
    } else {
      return (
        <div>
          <Loader className="flagship-loader" active={true} inline />
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userId: state.main.userId,
    instance: state.main.instance,
  };
}

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard.js